module.exports = __webpack_public_path__ + "static/media/ic-SLA.40710109.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-SLA.svg
// module id = 1287
// module chunks = 17